export default [
  {
    path: 'detectionStat/:sn?',
    name: 'cottonDetectionStat',
    component: () => import('@/views/cotton/statistics/detection'),
    props: true,
    meta: {
      hidden: true,
      noPadding: true
    }
  },
  {
    path: 'alarmStat/:sn?',
    name: 'cottonAlarmStat',
    component: () => import('@/views/cotton/statistics/alarm'),
    props: true,
    meta: {
      hidden: true,
      noPadding: true
    }
  }
];
